define([
    "../hereMapsModule",
    "text!./hereMapsRouteOverlapSelectionModal.html"
], function (hereMapsModule, hereMapsRouteOverlapSelectionModal) {
    "use strict";

    return hereMapsModule.directive("hereMapsRoutes", [
        "hereMapsService",
        function (hereMapsService) {
            return {
                restrict: "E",
                template: "<here-maps-markers on-register-api='onRouteMarkersRegisterApi'></here-maps-markers>",
                scope: {
                    routes: "=?",
                    onRegisterApi: "=",
                },
                controller: ["$scope", "$rootScope", "$timeout", "$compile", function ($scope, $rootScope, $timeout, $compile) {
                    $scope.Here = null;
                    $scope.map = null;
                    $scope.behavior = null;
                    $scope.ui = null;

                    var onRouteSelect = null;
                    var routeTapEvent = null;
                    var routeMarkersApi =  null;
                    var currentBubble = null;
                    var currentBubbleScope = null;
                    var padding = 50;
                    $scope.onRouteMarkersRegisterApi = function (api) {
                        routeMarkersApi = api;
                        $scope.onRegisterApi(routesApi);
                    };

                    function addEventsListerner() {
                        routeTapEvent = function (event) {
                            if (event.target instanceof $scope.Here.map.Polyline) {
                                var targetData = event.target.getData();
                                if(targetData){
                                    if (targetData.presentationNode && targetData.presentationNode.id) {
                                        if (onRouteSelect) {
                                            $scope.$apply(function() {
                                                onRouteSelect({
                                                    id: targetData.presentationNode.id
                                                });
                                            });
                                        }
                                    }
                                }
                            }
                        };
                        $scope.routesGroup.addEventListener("tap", routeTapEvent);
                    }

                    function updateRoutesOpacity() {
                        var routes = $scope.routesGroup.getObjects();
                        var hasSelected = routes.some(function(route) {
                            return route.getData() && route.getData().isSelected;
                        });

                        routes.forEach(function(route) {
                            var data = route.getData();
                            if(data){
                                var isOpaque = hasSelected && !data.isSelected;
                                var baseColor = route.getStyle().strokeColor.substring(0, 7);
                                route.setStyle({
                                    strokeColor: baseColor + (isOpaque ? "4D" : "")
                                });
                                route.setZIndex(isOpaque ? 0 : 999);

                                var markers = data.markers || [];
                                markers.forEach(function(marker) {
                                    updateMarkerOpacity(marker, isOpaque);
                                    marker.setZIndex(isOpaque ? 0 : 999);
                                });
                            }
                        });
                    }

                    function updateMarkerOpacity(marker, isOpaque) {
                        var data = marker.getData();
                        if(!data){
                            return;
                        }

                        var icon = data.icon;
                        if (!icon){
                            return;
                        }

                        data.originalHereIcon = data.originalHereIcon || marker.getIcon();
                        if (!isOpaque) {
                            return marker.setIcon(data.originalHereIcon);
                        }

                        var image = new Image();
                        image.onload = function() {
                            var canvas = document.createElement("canvas");
                            var iconContext = canvas.getContext("2d");
                            iconContext.globalAlpha = 0.3;
                            iconContext.drawImage(image, 0, 0);
                            marker.setIcon(new $scope.Here.map.Icon(canvas.toDataURL(), { anchor: {x: 16, y: 32} }));
                        };
                        image.src = icon;
                    }

                    init();

                    function init() {
                        $scope.Here = hereMapsService.getHere();
                        $scope.map = hereMapsService.getMap();
                        $scope.behavior = hereMapsService.getBehavior();
                        $scope.ui = hereMapsService.getUi();

                        $scope.routesGroup = new $scope.Here.map.Group();
                        $scope.staticRoutesGroup = new $scope.Here.map.Group();
                        $scope.mainGroup = new $scope.Here.map.Group({
                            volatility: true,
                            objects: [$scope.routesGroup, $scope.staticRoutesGroup],
                        });
                        $scope.map.addObject($scope.mainGroup);
                        addEventsListerner();
                    }

                    function focusOnRoute(routePolyline) {
                        var map = hereMapsService.getMap();
                        if (!map || !routePolyline) {
                            return;
                        }

                        map.getViewPort().setPadding(50, 50, 50, 50);
                        var routeBounds = routePolyline.getBoundingBox();
                        map.getViewModel().setLookAtData({
                            bounds: routeBounds
                        });
                    }

                    function toggleRoute(routePolyline, routeSelected) {
                        if (!routePolyline) {
                            return;
                        }

                        routePolyline.setVisibility(routeSelected);
                        var markers = routePolyline.getData().markers;
                        if (markers && markers.length > 0) {
                            markers.forEach(function (marker) {
                                marker.setVisibility(routeSelected);
                            });
                        }
                    }

                    function openNearbyRoutesBubble(nearbyMarkers, originalEvent, onRouteSelectedCallback) {
                        closeNearbyRoutesBubble();

                        var uniqueRoutes = [];
                        var seenTripCodes = {};
                        nearbyMarkers.forEach(function (marker) {
                            var data = marker.getData();
                            if (data && data.tripCode) {
                                if (!seenTripCodes[data.tripCode]) {
                                    seenTripCodes[data.tripCode] = true;
                                    uniqueRoutes.push(marker);
                                }
                            }
                        });

                        if (uniqueRoutes.length === 0){
                            return;
                        }

                        if (uniqueRoutes.length === 1) {
                            if(onRouteSelectedCallback) {
                                onRouteSelectedCallback(uniqueRoutes[0]);
                            }
                            return;
                        }

                        var position = originalEvent.target.getGeometry();
                        var modalOverlapRoutes = createModalOverlapRoutes({
                            routes: uniqueRoutes,
                            originalEvent: originalEvent
                        }, onRouteSelectedCallback);

                        currentBubble = new $scope.Here.ui.InfoBubble(position, {
                            content: modalOverlapRoutes
                        });
                        $scope.ui.addBubble(currentBubble);
                    }

                    function drawRoutesAndCenter(routes) {
                        for (var i = 0; i < routes.length; i++) {
                            var currentRoute = routes[i];
                            $scope.routesGroup.addObject(currentRoute);
                            drawRouteMarkers(currentRoute);
                        }

                        var boundingBox = $scope.mainGroup.getBoundingBox();

                        $scope.map.getViewPort().setPadding(padding, padding, padding, padding);

                        $scope.map.getViewModel().setLookAtData({
                            bounds: boundingBox,
                        });
                    }

                    function drawRouteMarkers(currentRoute) {
                        var markers = currentRoute.getData().markers;
                        if (markers && markers.length > 0) {
                            routeMarkersApi.addMarkers(markers);
                        }
                    }

                    function clearRouteMarkers(currentRoute) {
                        var markers = currentRoute.getData().markers;
                        if (markers && markers.length > 0) {
                            markers.forEach(function (marker) {
                                routeMarkersApi.clearMarker(marker);
                            });
                        }
                    }

                    function clearRoutes() {
                        if ($scope.routesGroup) {
                            routeMarkersApi.clearMarkers();
                            $scope.routesGroup.removeAll();
                        }
                    }

                    function clearRoute(route) {
                        if ($scope.routesGroup) {
                            clearRouteMarkers(route);
                            $scope.routesGroup.removeObject(route);
                        }
                    }

                    function clearStaticRoutes() {
                        if ($scope.staticRoutesGroup) {
                            $scope.staticRoutesGroup.removeAll();
                        }
                    }

                    function createModalOverlapRoutes(parameter, onRouteSelectedCallback) {
                        currentBubbleScope = $scope.$new(true);
                        currentBubbleScope.parameter = parameter;

                        currentBubbleScope.selectedRoute = null;
                        currentBubbleScope.chooseTrip = function (route) {
                            currentBubbleScope.selectedRoute = route;
                        };

                        currentBubbleScope.confirmSelection = function (route) {
                            closeNearbyRoutesBubble();
                            $timeout(function () {
                                if(onRouteSelectedCallback) {
                                    onRouteSelectedCallback(route);
                                }
                            });
                        };

                        var compiledElement = $compile(hereMapsRouteOverlapSelectionModal)(currentBubbleScope);
                        currentBubbleScope.close = function () {
                            closeNearbyRoutesBubble();
                        };

                        return compiledElement[0];
                    }

                    function closeNearbyRoutesBubble() {
                        if (currentBubble) {
                            $scope.ui.removeBubble(currentBubble);
                            currentBubble = null;
                        }

                        if (currentBubbleScope) {
                            currentBubbleScope.$destroy();
                            currentBubbleScope = null;
                        }
                    }

                    var routesApi = {};

                    routesApi.setOnRouteSelect = function (func) {
                        onRouteSelect = func;
                    };

                    routesApi.setTapAction = function (func) {
                        routeMarkersApi.setTapAction(func);
                    };

                    routesApi.setMarkerDragendAction = function (func) {
                        routeMarkersApi.setDragendAction(func);
                    };

                    routesApi.setHasTooltipInNearbyMarkersBubble = function (hasTooltip) {
                        routeMarkersApi.setHasTooltipInNearbyMarkersBubble(hasTooltip);
                    };

                    routesApi.addRoutes = function (routes) {
                        drawRoutesAndCenter(routes);
                    };

                    routesApi.clearRoutes = function () {
                        clearRoutes();
                    };

                    routesApi.clearRoute = function (route) {
                        clearRoute(route);
                    };

                    routesApi.focusOnStopByMarker = function (marker) {
                        routeMarkersApi.focusOnMarkerByMarker(marker);
                    };

                    routesApi.focusOnStopByCoordinate = function (coordinate) {
                        routeMarkersApi.focusOnMarkerByCoordinate(coordinate);
                    };

                    routesApi.focusOnRoute = function (route, currentBubble) {
                        focusOnRoute(route, currentBubble);
                    };

                    routesApi.toggleRoute = function (routePolyline, routeSelected) {
                        toggleRoute(routePolyline, routeSelected);
                    };

                    routesApi.clearStaticRoutes = function () {
                        clearStaticRoutes();
                    };

                    routesApi.addStaticRoute = function (routes) {
                        $scope.staticRoutesGroup.addObject(routes);
                    };

                    routesApi.setVisibilityStaticRoutes = function (visibility) {
                        $scope.staticRoutesGroup.setVisibility(visibility);
                    };

                    routesApi.getNearbyRoutesMarker = function (event) {
                        return routeMarkersApi.getNearbyMarkers(event);
                    };

                    routesApi.openNearbyMarkersBubble = function (nearbyMarkers, originalEvent, onMarkerSelectedCallback) {
                        routeMarkersApi.openNearbyMarkersBubble(nearbyMarkers, originalEvent, onMarkerSelectedCallback);
                    };

                    routesApi.openNearbyRoutesBubble = function (nearbyMarkers, originalEvent, onMarkerSelectedCallback) {
                        openNearbyRoutesBubble(nearbyMarkers, originalEvent, onMarkerSelectedCallback);
                    };

                    routesApi.syncRoutesOpacityWithSelection = function (selectedTripIds) {
                        if (!$scope.routesGroup){
                            return;
                        }

                        var routes = $scope.routesGroup.getObjects();
                        routes.forEach(function (route) {
                            var data = route.getData();
                            if (data && data.presentationNode) {
                                data.isSelected = selectedTripIds.includes(data.presentationNode.id);
                                route.setData(data);
                            }
                        });
                        updateRoutesOpacity();
                    };

                    $scope.$on("$destroy", function () {
                        if ($scope.map) {
                            if ($scope.routesGroup) {
                                $scope.routesGroup.removeEventListener("tap", routeTapEvent);
                            }
                            if ($scope.mainGroup) {
                                $scope.mainGroup.removeAll();
                            }

                            $scope.Here = null;
                            $scope.map = null;
                            $scope.behavior = null;
                            $scope.mainGroup = null;
                            $scope.routesGroup = null;
                        }
                    });
                }]
            };
        }
    ]);
});